export default __webpack_public_path__ + "8be2d1487420548b3b8ddba68270b26b.ttf";